var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 362,
    height: 184,
    viewBox: "0 0 362 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2987 140.149L0 146.474V185.614H793V44.3445C782.701 38.1606 762.104 25.7928 741.507 29.8555C720.909 33.9183 700.312 54.4117 679.714 65.2644C659.117 76.1172 638.519 77.3293 617.922 74.8498C597.325 72.3702 576.727 66.199 556.13 67.2636C535.532 68.3282 514.935 76.6285 494.338 72.6714C473.74 68.7142 453.143 52.4996 432.545 47.8211C411.948 43.1427 391.351 50.0004 370.753 62.1693C350.156 74.3382 329.558 91.8181 308.961 92.9397C288.364 94.0613 267.766 78.8245 247.169 81.416C226.571 84.0075 205.974 104.427 185.377 107.417C164.779 110.407 144.182 95.9665 123.584 93.2465C102.987 90.5265 82.3896 99.5269 61.7922 110.352C41.1948 121.176 20.5974 133.825 10.2987 140.149Z",
    fill: "url(#paint0_linear_552_2738)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 146.877L10.2987 140.531C20.5974 134.185 41.1948 121.493 61.7922 110.631C82.3896 99.7691 102.987 90.7378 123.584 93.4672C144.182 96.1965 164.779 110.686 185.377 107.686C205.974 104.686 226.571 84.1964 247.169 81.596C267.766 78.9956 288.364 94.2848 308.961 93.1593C329.558 92.0339 350.156 74.4938 370.753 62.2831C391.351 50.0724 411.948 43.1911 432.545 47.8856C453.143 52.5802 473.74 68.8506 494.338 72.8213C514.935 76.792 535.532 68.4631 556.13 67.3949C576.727 66.3267 597.325 72.5191 617.922 75.0072C638.519 77.4952 659.117 76.2789 679.714 65.3889C700.312 54.4988 720.909 33.935 741.507 29.8583C762.104 25.7816 782.701 38.1919 793 44.397",
    stroke: "#835C50",
    strokeOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_552_2738",
    x1: 396.5,
    y1: 29.0527,
    x2: 396.5,
    y2: 185.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#835C50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#835C50",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg2);
export default __webpack_public_path__ + "static/media/svg2.ff8a1d4ece34e2a8a58964119a33294f.svg";
export { ForwardRef as ReactComponent };